export default __webpack_public_path__ + "static/media/effect1.6b8b0938.png";